import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import { BalanceDisplay } from './balanceDisplay';
import { AgeDateDisplay } from './ageDateDisplay';

export const FineTuneResult = ({
  desiredEndBalance, desiredEndBalanceDisplay, desiredEndBalanceDisplayPrompt,
  primaryClientBirthDate, spouseClientBirthDate,
}) => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack direction={'row'} spacing={2}>
      <MetaControlField
        attr={'primaryClientSuggestedRetirementAge'}
        dateField={'primaryClientSuggestedRetirementDate'}
        startAge={primaryClientBirthDate}
        {...dataAttrs('retirement-age-goal-seek-primary-age-input')}
      />
      <MetaControlField
        attr={'spouseClientSuggestedRetirementAge'}
        dateField={'spouseClientSuggestedRetirementDate'}
        startAge={spouseClientBirthDate}
        {...dataAttrs('retirement-age-goal-seek-spouse-age-input')}
      />
      <MetaControlField
        attr={'endBalanceDisplay'}
        helperText={`${desiredEndBalanceDisplayPrompt}: ${desiredEndBalanceDisplay}`}
        desiredEndBalance={desiredEndBalance}
        remainingEndBalance={parseInt(resource.attr('remainingEndBalance'), 10)}
      />
    </FDStack>
  );
};

FineTuneResult.propTypes = {
  desiredEndBalance: PropTypes.number.isRequired,
  desiredEndBalanceDisplayPrompt: PropTypes.string.isRequired,
  desiredEndBalanceDisplay: PropTypes.string.isRequired,
  primaryClientBirthDate: PropTypes.string.isRequired,
  spouseClientBirthDate: PropTypes.string,
};

FineTuneResult.defaultProps = {
  spouseClientBirthDate: '',
};

export const FineTuneResultOverrides = buildFacetDesignOverride()
  .nameOverride('endBalanceDisplay', {
    _component: () => BalanceDisplay,
  }, overrideReadOnly)
  .nameOverride(['primaryClientSuggestedRetirementAge', 'spouseClientSuggestedRetirementAge'], {
    _component: () => AgeDateDisplay,
  }, overrideReadOnly);
